import { render, staticRenderFns } from "./ShoppingCartHeader.vue?vue&type=template&id=6b57d162&"
import script from "./ShoppingCartHeader.vue?vue&type=script&lang=js&"
export * from "./ShoppingCartHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports